import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

// Async thunks
export const getLabours = createAsyncThunk('/GetLabours', async () => {
  const response = await axios.get(`/GetLabours`);
  return response.data;
});

export const getLabourDetails = createAsyncThunk(
  '/GetLabourDetails',
  async labourId => {
    const response = await axios.get(`/GetLabourDetails/${labourId}`);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const setCatalogItem = createAsyncThunk(
  '/SetCatalogItem',
  async data => {
    const response = await axiosHeadOffice.post(
      '/HeadOffice/SetCatalogItem',
      data
    );
    return response.data;
  }
);

// localStorage helper fonksiyonları
const MATERIAL_ID_MAP_KEY = 'labourMaterialIdMap';

const loadMaterialIdMap = () => {
  try {
    const saved = localStorage.getItem(MATERIAL_ID_MAP_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch (error) {
    return {};
  }
};

const saveMaterialIdMap = (map) => {
  try {
    localStorage.setItem(MATERIAL_ID_MAP_KEY, JSON.stringify(map || {}));
  } catch (error) {
    console.error('MaterialIdMap kaydedilirken hata:', error);
  }
};

const labourSlice = createSlice({
  name: 'labour',
  initialState: {
    loading: false,
    error: '',
    MainLanguageDescription: '',
    labours: [],
    labourDescriptions: [],
    SelectedAppTranslationId: 0,
    SelectedLabourCode: '',
    IsChecked: true,
    SelectedMaterialId: 0,
    materialIdMap: loadMaterialIdMap(), // localStorage'dan yükle
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    changeSelectedLabourCode(state, action) {
      const newCode = action.payload;
      state.SelectedLabourCode = newCode;
      
      // materialIdMap yoksa oluştur
      if (!state.materialIdMap) {
        state.materialIdMap = {};
      }
      
      // Bu LabourCode için kayıtlı MaterialId varsa yükle
      if (newCode && state.materialIdMap[newCode]) {
        state.SelectedMaterialId = state.materialIdMap[newCode];
      } else {
        state.SelectedMaterialId = 0;
      }
    },
    resetDescriptions(state) {
      state.labourDescriptions = [];
      state.SelectedAppTranslationId = 0;
      state.MainLanguageDescription = '';
      state.SelectedMaterialId = 0;
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    },
    changeMainLanguageDescription(state, action) {
      state.MainLanguageDescription = action.payload;
    },
    changeLabourDescriptions(state, action) {
      state.labourDescriptions = action.payload;
    },
    changeSelectedMaterialId: (state, action) => {
      const materialId = action.payload;
      state.SelectedMaterialId = materialId;
      
      // materialIdMap yoksa oluştur
      if (!state.materialIdMap) {
        state.materialIdMap = {};
      }
      
      // MaterialId'yi LabourCode ile eşleştir ve localStorage'a kaydet
      if (state.SelectedLabourCode && materialId && materialId !== 0) {
        state.materialIdMap[state.SelectedLabourCode] = materialId;
        saveMaterialIdMap(state.materialIdMap);
      }
    },
  },
  extraReducers: {
    [getLabours.pending]: state => {
      state.loading = true;
    },
    [getLabours.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLabours.fulfilled]: (state, action) => {
      state.labours = action.payload;
      state.loading = false;
    },
    [getLabourDetails.pending]: state => {
      state.loading = true;
    },
    [getLabourDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLabourDetails.fulfilled]: (state, action) => {
      state.labourDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: state => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.labourDescriptions = action.payload;
      state.loading = false;
    },
    // setCatalogItem başarılı olduğunda
    [setCatalogItem.pending]: state => {
      state.loading = true;
    },
    [setCatalogItem.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setCatalogItem.fulfilled]: (state, action) => {
      state.loading = false;
      
      // Backend'den MaterialId döndüyse kaydet
      if (action.payload?.Data?.MaterialId && state.SelectedLabourCode) {
        const materialId = action.payload.Data.MaterialId;
        state.SelectedMaterialId = materialId;
        
        // materialIdMap'e kaydet
        if (!state.materialIdMap) {
          state.materialIdMap = {};
        }
        state.materialIdMap[state.SelectedLabourCode] = materialId;
        saveMaterialIdMap(state.materialIdMap);
              }
    }
  }
});

export const labourActions = labourSlice.actions;
export default labourSlice;